/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { WorkSession__ItemEntityFragmentDoc } from '../Fragments.generated.js';
import { TaskTreeItem_TreeSimpleItemFragmentDoc } from '../../tasks/trees.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWorkSessionsMutationVariables = Types.Exact<{
  input: Types.CreateWorkSessionsInput;
}>;


export type CreateWorkSessionsMutation = { createWorkSessions: { __typename: 'CreateWorkSessionsResult', workSessions: Array<{ __typename: 'WorkSession', id: string }>, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, workSessionsDuration: number, workSessions: Array<{ __typename: 'WorkSession', id: string, till?: any | null, from?: any | null, date?: any | null, duration?: number | null, isCorrection: boolean, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, author: { __typename: 'User', id: string, firstname: string, familyname: string } }> } } };

export type AddTaskWorkSessionsModal_ItemFragment = { __typename: 'Item', id: string, docId: string, title: string, type: Types.ItemType, isDone: boolean, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, deletedAt?: any | null, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, timeTrackingRequired: boolean, photoApprovalRequired: boolean, qaApprovalRequired: boolean, approvalRequired: boolean, workSessionsDuration: number, dueDate?: any | null, doneDate?: any | null, priority: number, isVisibleToOtherSide: boolean, isQaApproved?: boolean | null, isApproved?: boolean | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export const AddTaskWorkSessionsModal_ItemFragmentDoc = gql`
    fragment AddTaskWorkSessionsModal_Item on Item {
  id
  docId
  ...TaskTreeItem_TreeSimpleItem
}
    ${TaskTreeItem_TreeSimpleItemFragmentDoc}`;
export const CreateWorkSessionsDocument = gql`
    mutation CreateWorkSessions($input: CreateWorkSessionsInput!) {
  createWorkSessions(input: $input) {
    workSessions {
      id
    }
    item {
      id
      originVersionNumber
      workSessionsDuration
      workSessions {
        id
        ...WorkSession__ItemEntity
      }
    }
  }
}
    ${WorkSession__ItemEntityFragmentDoc}`;
export type CreateWorkSessionsMutationFn = Apollo.MutationFunction<CreateWorkSessionsMutation, CreateWorkSessionsMutationVariables>;

/**
 * __useCreateWorkSessionsMutation__
 *
 * To run a mutation, you first call `useCreateWorkSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkSessionsMutation, { data, loading, error }] = useCreateWorkSessionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkSessionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkSessionsMutation, CreateWorkSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkSessionsMutation, CreateWorkSessionsMutationVariables>(CreateWorkSessionsDocument, options);
      }
export type CreateWorkSessionsMutationHookResult = ReturnType<typeof useCreateWorkSessionsMutation>;
export type CreateWorkSessionsMutationResult = Apollo.MutationResult<CreateWorkSessionsMutation>;
export type CreateWorkSessionsMutationOptions = Apollo.BaseMutationOptions<CreateWorkSessionsMutation, CreateWorkSessionsMutationVariables>;